import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { withTranslation } from 'react-i18next';
import { gql, useApolloClient, useQuery } from '@apollo/client';
import Header from '../components/Headers/Header';
import CustomLoader from '../components/Loader/CustomLoader';
import { GetReplenishableProductsForWorker } from '../apollo';
import DataTable from 'react-data-table-component';
import orderBy from 'lodash/orderBy';
import { customStyles } from '../utils/tableforManageRepletion';
import useGlobalStyles from '../utils/globalStyles';
import { Icon } from '@iconify/react';
import {
  Container,
  Button,
  Box,
  TextField,
  Autocomplete,
  Paper
} from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import TableHeader from '../components/TableHeader';
import VerifyStockRequestModal from './VerifyStockRequestModal'; // Import the modal component

const GET_REPLENTION_PRODUCTS = gql`${GetReplenishableProductsForWorker}`;

const CustomPaperComponent = (props) => (
  <Paper {...props} style={{ background: 'white', color: 'black' }} />
);

const CreateNewReplentionRequest = props => {
  const { t } = props;
  const [editMode, setEditMode] = useState(null);
  const [editedLocalQty, setEditedLocalQty] = useState({});
  const [requestedQty, setRequestedQty] = useState({});
  const [editedRows, setEditedRows] = useState([]);
  const [mergedModalData, setMergedModalData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false); // State for modal visibility
  const [reasons, setReasons] = useState({});
  const userDetailsStr = localStorage.getItem('user-native');
  const userDetails = JSON.parse(userDetailsStr);
  const golbalClasses = useGlobalStyles();
  const client = useApolloClient();
  const [page, setPage] = useState(1);
  const [tabledata, setTabledata] = useState([]);
  const [currentPage, setCurrentPage] = useState(page);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  // const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const inputTextStyle = { color: 'black' };
  const [selectedRowMap, setSelectedRowMap] = useState({});
  //const isPageChangingRef = React.useRef(false);
  const [clearSelectionToggle, setClearSelectionToggle] = useState(false);



  const log = function (label, data) {
    console.log(
      '*%c' + label,
      'color:#1976d2;font-weight:bold;',
      JSON.parse(JSON.stringify(data))
    );
  };
  // const [selectedRowsForModal, setSelectedRowsForModal] = useState([]);
  const reasonOptions = [
    { label: "NEED REPLENISH", id: 0 },
    { label: "QUNTITY SAME CS", id: 1 },
    { label: "QUNTITY CHANGE CS", id: 2 },
    { label: "QUNTITY NOT AVAILABLE", id: 3 },
    { label: "QUNTITY DAMAGED TRANSIT", id: 4 },
    { label: "QUNTITY MISSING TRANSIT", id: 5 },
    { label: "ITEM REMOVED", id: 6 },
    { label: "REPLENISHED", id: 7 }
  ];

  const handleBackClick = () => {
    localStorage.removeItem('selectedRowIds'); // Remove selectedRowIds from local storage
    localStorage.removeItem('editedRows');

    // Determine the route based on workerType
    const workerType = userDetails.workerType;
    const route = workerType === 0
      ? '/package_admin/repletion'
      : '/billing_admin/repletion';

    props.history.push({
      pathname: route,
    });// Navigate back to ManageCategory component
  };

  const variables = {
    limit: perPage,
    skip: (page - 1) * perPage,
  };

  const { loading: loadingQuery, error: errorQuery, data, refetch } = useQuery(
    GET_REPLENTION_PRODUCTS, {
    variables,
    onCompleted: (data) => {
      let fetchedData = data && data.getReplenishableProductsForWorker.products ? data.getReplenishableProductsForWorker.products : [];
      // Merge the edited rows with the fetched data
      log(
        ' DATA FETCHED',
        data.getReplenishableProductsForWorker.products.map(p => p._id)
      );

      const updatedData = mergeEditedData(fetchedData);
      setTabledata(updatedData);
      setTotalRows(data.getReplenishableProductsForWorker.totalCount);
    },
    onError: error => {
      const isForbiddenError = error && error.graphQLErrors.some(err => err.extensions.code === 'FORBIDDEN');
      if (isForbiddenError) {
        localStorage.removeItem('user-native');
        localStorage.removeItem('restaurant_id');
        client.clearStore();
        props.history.push('/auth/login');
      }
    },
  }
  );

  useEffect(() => {
    if (data && data.getReplenishableProductsForWorker.products) {
      let fetchedData = data.getReplenishableProductsForWorker.products;
      // Merge the edited rows with the fetched data
      const updatedData = mergeEditedData(fetchedData);
      setTabledata(updatedData);
      setTotalRows(data.getReplenishableProductsForWorker.totalCount);
    }
  }, [data]);

  useEffect(() => {
    refetch({
      variables: {
        limit: perPage,
        skip: (page - 1) * perPage,
      },
    });
  }, [page, perPage, refetch]);

  const handlePerRowChange = (newPerPage) => {
    setPerPage(newPerPage);
  };

  const handlePageChange = (page) => {
    console.log(' PAGE CHANGE', {
      from: currentPage,
      to: page
    });
    // isPageChangingRef.current = true;
    // setClearSelectionToggle(prev => !prev); 
    setPage(page);
    setCurrentPage(page);
  };

  const handleEditClick = (row) => {
    setEditMode(row._id);
    setEditedLocalQty(prev => ({ ...prev, [row._id]: row.localQty }));
    setRequestedQty(prev => ({
      ...prev,
      [row._id]:
        row.requestedQty !== undefined && row.requestedQty !== null
          ? row.requestedQty
          : row.defaultLSQty - row.localQty - row.replenishQty
    }));
    setReasons(prev => ({
      ...prev,
      [row._id]:
        prev[row._id] ||
        reasonOptions.find(r => r.id === row.reason) ||
        { label: "NEED REPLENISH", id: 0 }
    }));
  };

  const handleSaveClick = (row) => {
    const updatedRow = {
      ...row,
      localQty: editedLocalQty[row._id],
      requestedQty: requestedQty[row._id],
      reason: reasons[row._id].id
    };

    //  Update editedRows (already correct)
    setEditedRows(prev => {
      const index = prev.findIndex(r => r._id === row._id);
      const updated = index !== -1
        ? prev.map(r => (r._id === row._id ? updatedRow : r))
        : [...prev, updatedRow];

      localStorage.setItem('editedRows', JSON.stringify(updated));
      return updated;
    });

    //  Update tabledata (already correct)
    setTabledata(prev =>
      prev.map(r => (r._id === row._id ? updatedRow : r))
    );

    //  UPDATE selectedRowMap (THIS WAS MISSING)
    setSelectedRowMap(prev => {
      if (!prev[row._id]) return prev; // only if selected

      return {
        ...prev,
        [row._id]: {
          ...prev[row._id],
          requestedQty: updatedRow.requestedQty,
          reason: updatedRow.reason,
          localQty: updatedRow.localQty,
        }
      };
    });

    setEditMode(null);
  };

  const handleCancelClick = () => {
    setEditMode(null);
  };
  const handleRequestedQtyChange = (id, value) => {
    setRequestedQty(prev => ({ ...prev, [id]: value }));
  };

  const handleReasonChange = (id, value) => {
    setReasons(prev => ({ ...prev, [id]: value }));
  };
  const handleRowSelected = (state) => {
    const pageSelectedIds = state.selectedRows.map(r => r._id);

    setSelectedRowMap(prevMap => {
      const prevIds = Object.keys(prevMap);

      //  Detect if ANY row on this page is still visually selected
      const anyCheckedOnPage = tabledata.some(
        row => prevMap[row._id]
      );

      //  Ignore ONLY true internal reset
      if (
        pageSelectedIds.length === 0 &&
        prevIds.length > 0 &&
        anyCheckedOnPage
      ) {
        console.log(' Ignoring INTERNAL reset');
        return prevMap;
      }

      const updatedMap = { ...prevMap };


      state.selectedRows.forEach(row => {
        if (!updatedMap[row._id]) {
          const calcQty = Math.max(
            row.defaultLSQty - row.localQty - row.replenishQty,
            0
          );

          updatedMap[row._id] = {
            ...row,
            requestedQty:
              requestedQty[row._id] !== undefined &&
                requestedQty[row._id] !== null
                ? requestedQty[row._id]
                : calcQty,
            reason:
              reasons[row._id] && reasons[row._id].id !== undefined
                ? reasons[row._id].id
                : 0
          };

          console.log(' USER SELECT', row._id);
        }
      });

      // REMOVE unchecked rows (real user unselect)
      tabledata.forEach(row => {
        if (
          updatedMap[row._id] &&
          pageSelectedIds.indexOf(row._id) === -1
        ) {
          delete updatedMap[row._id];
          console.log(' USER UNSELECT', row._id);
        }
      });

      const ids = Object.keys(updatedMap);
      console.log(' FINAL SELECTED IDS', ids);

      setSelectedRowIds(ids);
      localStorage.setItem('selectedRowIds', JSON.stringify(ids));

      return updatedMap;
    });
  };





  const columns = useMemo(() => [
    {
      name: "Product Name",
      sortable: true,
      selector: 'name',
      style: { cursor: 'pointer' },
    },
    {
      name: "SKU ID",
      sortable: true,
      selector: 'skuId',
      style: { cursor: 'pointer' },
    },
    {
      name: "Local Quantity",
      sortable: true,
      selector: 'localQty',
      style: { cursor: 'pointer', minWidth: "150px" },
    },
    {
      name: "Minimum Quantity",
      sortable: true,
      selector: 'minimumQty',
      style: { cursor: 'pointer' },
    },
    {
      name: "Default Quantity",
      sortable: true,
      selector: 'defaultLSQty',
      style: { cursor: 'pointer' },
    },

    {
      name: "Replenish Quantity",
      sortable: true,
      selector: 'replenishQty',
      style: { cursor: 'pointer' },
    },
    {
      name: "Require Quantity",
      cell: row =>
        editMode === row._id ? (
          <TextField
            inputProps={{ style: inputTextStyle }}
            type="text"
            autoFocus
            value={requestedQty[row._id]}
            onChange={e =>
              handleRequestedQtyChange(row._id, e.target.value)
            }
          />
        ) : (
          requestedQty[row._id] !== undefined &&
            requestedQty[row._id] !== null
            ? requestedQty[row._id]
            : (row.defaultLSQty - row.localQty - row.replenishQty)
        ),
    },
    {
      name: "Reason",
      cell: row => editMode === row._id ? (
        <Autocomplete
          style={{ minWidth: "100%" }}
          options={reasonOptions}
          getOptionLabel={(option) => option.label}
          value={reasons[row._id]}
          onChange={(e, value) => handleReasonChange(row._id, value)}
          renderInput={(params) => <TextField {...params}
            variant="outlined"
            inputProps={{ ...params.inputProps, style: inputTextStyle }}
          />}
          PaperComponent={CustomPaperComponent}
        />
      ) : (
        reasons[row._id] ? reasons[row._id].label : "NEED REPLENISH"
      ),
      style: { cursor: 'pointer', minWidth: "150px" },
    },
    {
      name: 'Action',
      cell: row => selectedRowIds.includes(row._id) ? (
        editMode === row._id ? (
          <>
            <Button onClick={() => handleSaveClick(row)}>Save</Button>
            <Button onClick={handleCancelClick}>Cancel</Button>
          </>
        ) : (
          <Button onClick={() => handleEditClick(row)}>Edit</Button>
        )
      ) : null,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ],
    [editMode, handleSaveClick, handleCancelClick, handleEditClick, editedLocalQty, requestedQty, reasons, selectedRowIds]);
  const customSort = useCallback((rows, selector, direction) => {
    const handleField = row => {
      if (typeof selector === 'function') {
        const data = selector(row);
        return data ? data.toString().toLowerCase() : "";
      }
      return "";
    };
    return orderBy(rows, handleField, direction);
  }, []);

  const handlePrint = () => {
    const rows = Object.values(selectedRowMap);
    const doc = new jsPDF();
    const tableColumn = ["Product Name", "Local Quantity", "Minimum Quantity", "SKU ID", "Requested Quantity", "Reason"];
    const tableRows = rows.map(row => [
      row.name,
      row.localQty,
      row.minimumQty,
      row.skuId,
      requestedQty[row._id] !== undefined &&
        requestedQty[row._id] !== null
        ? requestedQty[row._id]
        : (row.defaultLSQty - row.localQty - row.replenishQty),

      reasons[row._id] ? reasons[row._id].label : "NEED REPLENISH"
    ]);

    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 20,
      theme: 'grid',
      columnStyles: {
        0: { cellWidth: 40 },
        1: { cellWidth: 40 },
        2: { cellWidth: 40 },
        3: { cellWidth: 40 },
        4: { cellWidth: 40 },
        5: { cellWidth: 40 }
      },
    });

    doc.save('selected_products.pdf');
  };

  useEffect(() => {
    // Get the selected row IDs from local storage
    const storedIds = localStorage.getItem('selectedRowIds');
    const storedEditedRows = localStorage.getItem('editedRows');
    if (storedIds) {
      setSelectedRowIds(JSON.parse(storedIds));
    }
    if (storedEditedRows) {
      const parsedEditedRows = JSON.parse(storedEditedRows);
      setEditedRows(parsedEditedRows);
      // Set the requested quantity and reason for the parsed edited rows
      const requestedQtyState = {};
      const reasonsState = {};
      parsedEditedRows.forEach(row => {
        requestedQtyState[row._id] = row.requestedQty;
        reasonsState[row._id] = reasonOptions.find(option => option.id === row.reason) || { label: "NEED REPLENISH", id: 0 };
      });
      setRequestedQty(requestedQtyState);
      setReasons(reasonsState);
    }
  }, []);

  const mergeEditedData = (fetchedData) => {
    const storedEditedRows = JSON.parse(
      localStorage.getItem('editedRows') || '[]'
    );

    const editedMap = new Map(
      storedEditedRows.map(row => [row._id, row])
    );

    return fetchedData.map(row => {
      if (editedMap.has(row._id)) {
        return {
          ...row,
          ...editedMap.get(row._id), // FULL overwrite
        };
      }
      return row;
    });
  };
  const handleOpenModal = () => {
    const selectedItems = Object.values(selectedRowMap);

    console.log(' SUBMIT CLICK - selected items', selectedItems);

    setMergedModalData(selectedItems);
    setIsModalOpen(true);
  };
  useEffect(() => {
  }, [editMode])
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleSubmit = () => {
    const payload = {
      comments: null,
      requestedItems: Object.values(selectedRowMap),
    };

    console.log('FINAL SUBMIT PAYLOAD', payload);

    handleCloseModal();
  }; useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.key === 'Escape') {
        setSelectedRowMap({});
        setSelectedRowIds([]);
        localStorage.removeItem('selectedRowIds');
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  const mergeRows = (editedRows, selectedRows) => {
    const editedRowsMap = new Map(editedRows.map(row => [row._id, row]));

    return selectedRows.map(row => {
      if (editedRowsMap.has(row._id)) {
        return { ...row, ...editedRowsMap.get(row._id) };
      }
      return row;
    });
  };

  return (
    <>
      <Header />
      <Container className={golbalClasses.flex}>
        {errorQuery ? <span> `Error! ${errorQuery.message}`</span> : null}
        {loadingQuery ? (
          <CustomLoader />
        ) : (
          <>
            <Box sx={{ textAlign: 'right', mb: 3 }}>
              <Button
                className={golbalClasses.dashbordBtn}
                onClick={handleOpenModal}
              >
                <Icon icon="ic:twotone-plus" style={{ color: "white" }} /> {t('Submit Stock Request')}
              </Button>
              <Button
                className={golbalClasses.dashbordBtn}
                onClick={handlePrint}
              >
                <Icon icon="gridicons:print" style={{ color: "white" }} /> {t('Print')}
              </Button>
              <Button
                className={golbalClasses.dashbordBtn}
                onClick={() => {
                  setSelectedRowMap({});
                  setSelectedRowIds([]);
                  localStorage.removeItem('selectedRowIds');
                  // Toggle this to trigger the UI refresh in the DataTable
                  setClearSelectionToggle(prev => !prev);
                  console.log('CLEARED ALL SELECTIONS');
                }}
              >
                <Icon icon="mdi:trash" style={{ color: "white" }} /> Clear All
              </Button>
              <Button className={golbalClasses.dashbordBtn} onClick={handleBackClick}>
                <ArrowBackIosIcon onClick={handleBackClick} /> {t('Back')}
              </Button>
            </Box>
            <DataTable
              subHeader={true}
              key={currentPage}
              title={<TableHeader title={t('Manage Replention ')} />}
              columns={columns}
              data={tabledata || []}
              progressPending={loadingQuery}
              progressComponent={<CustomLoader />}
              paginationDefaultPage={currentPage}
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              onChangeRowsPerPage={handlePerRowChange}
              onChangePage={handlePageChange}
              sortFunction={customSort}
              selectableRows
              clearSelectedRows={clearSelectionToggle}
              selectableRowSelected={(row) => {
                const checked = selectedRowIds.indexOf(row._id) !== -1;

                console.log(
                  ' CHECKBOX RENDER',
                  row._id,
                  'checked =',
                  checked
                );

                return checked;
              }}
              onSelectedRowsChange={handleRowSelected}
              customStyles={customStyles} // Pass customStyles here
            />
          </>
        )}
      </Container>

      <VerifyStockRequestModal
        open={isModalOpen}
        onClose={handleCloseModal}
        editedRows={mergedModalData}
        onSubmit={handleSubmit}
        t={t}
        // selectedRows={selectedRowsForModal}
        refetch={refetch}
      // customStyles={customStyles} // Pass customStyles here
      />



    </>
  );
};

export default withTranslation()(CreateNewReplentionRequest);
